import Entity from './entity'
export default class TransferOrder extends Entity<number>{

    ordernumber	:string;//		订单编号
regulatorycode	:string;//	否		监管代码
productionwasteid	:number;//	否	外键产废单位	企业ID
collectionofficeid	:number;//	否	外键收处单位	企业ID
hazardouswaste	:string;//	否		危废物
smartdevices	:string;//	否		智能设备
weight	:number;//			申报量（kg）
transfertime	:Date;//			转移时间
quantity	:number;//			数量
shipper 	:string;// 			发运人
deliveryaddress	:string;//		送达地
declarestatus	:number;//			申报状态0 待出来 1确认接单2 作废订单
declaretime	:Date;//			申报时间
transweight	:number;//			转移量（kg）
transportedid	:number;//		外键运输单位	企业运输单位ID
transportationstartingpoint:string;//	:string;//			运输起点
throughtheland	:string;//			经由地
transportationendpoint:string;//	:string;//			运输终点
modeoftransport	:string;//			运输方式
vehicle	:string;//			车辆
transporter	:string;//			运输人
transportationtime	:Date;//			运输时间
dispatchcarstatus	:number;//			派车状态 0待派车 1已派车
dispatchcartime	:Date;//			派车时间
signforweight	:number;//			签收量(kg)
waybillnumber	:string;//			运单编号
signee	:string;//			接收人
signeetime	:Date;//			接受时间
disposalmethod	:string;//			处置方式
acceptingunitleader	:string;//			接受单位负责人
signstatus	:number;//			接受状态 0待签收1 已签收
signtime	:Date;//			修改状态时间
hid:number;//危废信息
transportationphone:string;//运输人电话
}